(function () {
  function removeEmptyHeadings() {
    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');

    headings.forEach(function (heading) {
      const text = heading.textContent.replace(/\u00A0/g, ' ').trim(); // strips &nbsp; too
      const hasImage = heading.querySelector('img, svg');
      const hasIcon  = heading.querySelector('[class*="icon"], [class*="fa-"], [aria-hidden]');

      if (!text && !hasImage && !hasIcon) {
        heading.remove();
      }
    });
  }

  // ── 1. Run on initial DOM ready ──────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeEmptyHeadings);
  } else {
    removeEmptyHeadings();
  }

  // ── 2. Re-run after full page load (catches late-injected content) ──
  window.addEventListener('load', removeEmptyHeadings);

  // ── 3. Watch for 3rd-party / dynamic content added after load ──
  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      const hasNewNodes = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (hasNewNodes) removeEmptyHeadings();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

//Alt
(function () {
  function fixMissingAlt() {
    // Only targets images that have NO alt attribute at all
    const images = document.querySelectorAll('img:not([alt])');

    images.forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  // ── 1. Run on DOM ready ──────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMissingAlt);
  } else {
    fixMissingAlt();
  }

  // ── 2. Re-run after full load (catches lazy-loaded images) ───
  window.addEventListener('load', fixMissingAlt);

  // ── 3. Watch for dynamically injected images ─────────────────
  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return; // element nodes only

          // If the added node itself is an img without alt
          if (node.tagName === 'IMG' && !node.hasAttribute('alt')) {
            node.setAttribute('alt', '');
          }

          // If the added node contains nested imgs without alt
          node.querySelectorAll('img:not([alt])').forEach(function (img) {
            img.setAttribute('alt', '');
          });
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

//h1
(function () {
  function addHiddenH1FromTitle() {
    // ── 1. Check if page already has an h1 ──────────────────────
    const existingH1 = document.querySelector('h1');
    if (existingH1) return; // h1 exists — do nothing

    // ── 2. Get text from <title>, strip site name after separator ─
    const rawTitle = document.title || '';
    const pageTitle = rawTitle
      .split(/[|\-–—]/)  // split on | - – —
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; })[0] || rawTitle.trim();

    if (!pageTitle) return; // no title text found — bail

    // ── 3. Create visually hidden h1 ────────────────────────────
    const h1 = document.createElement('h1');
    h1.textContent = pageTitle;

    // Visually hidden but fully accessible to screen readers
    h1.style.cssText = [
      'position: absolute',
      'width: 1px',
      'height: 1px',
      'padding: 0',
      'margin: -1px',
      'overflow: hidden',
      'clip: rect(0, 0, 0, 0)',
      'white-space: nowrap',
      'border: 0'
    ].join('; ');

    // ── 4. Inject as first element inside <main> or <body> ───────
    const target = document.querySelector('main') ||
                   document.querySelector('[role="main"]') ||
                   document.body;

    target.insertBefore(h1, target.firstChild);
  }

  // ── Run on DOM ready ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addHiddenH1FromTitle);
  } else {
    addHiddenH1FromTitle();
  }

})();

//linked images
(function () {
  function fixLinkedImageAlt() {
    // Target <a> tags that contain images but have no accessible name
    const linkedImages = document.querySelectorAll('a img');

    linkedImages.forEach(function (img) {
      const link = img.closest('a');
      if (!link) return;

      // Skip if the link already has an accessible name
      const hasAriaLabel    = link.hasAttribute('aria-label') && link.getAttribute('aria-label').trim() !== '';
      const hasAriaLabelledBy = link.hasAttribute('aria-labelledby');
      const hasTitle        = link.hasAttribute('title') && link.getAttribute('title').trim() !== '';
      const hasLinkText     = link.textContent.trim() !== '';

      if (hasAriaLabel || hasAriaLabelledBy || hasTitle || hasLinkText) return;

      // ── Get the best label from the image itself ──────────────
      const imgAlt   = img.getAttribute('alt')   || '';
      const imgTitle = img.getAttribute('title') || '';
      const label    = imgAlt.trim() || imgTitle.trim();

      if (label) {
        // Image has meaningful alt — copy it to the link
        link.setAttribute('aria-label', label);
      } else {
        // Image has no useful alt — mark link as decorative
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
      }
    });
  }

  // ── 1. Run on DOM ready ──────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixLinkedImageAlt);
  } else {
    fixLinkedImageAlt();
  }

  // ── 2. Re-run after full load (lightbox / lazy content) ──────
  window.addEventListener('load', fixLinkedImageAlt);

  // ── 3. Watch for dynamically injected linked images ──────────
  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      const hasNewNodes = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (hasNewNodes) fixLinkedImageAlt();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
//select
(function () {
  function addSelectAriaLabels() {
    const selects = document.querySelectorAll('select:not([aria-label]):not([aria-labelledby])');

    selects.forEach(function (select) {
      // ── 1. Check for an associated <label> element first ──────
      const id = select.getAttribute('id');
      if (id) {
        const associatedLabel = document.querySelector('label[for="' + id + '"]');
        if (associatedLabel && associatedLabel.textContent.trim()) {
          return; // already labelled via <label for=""> — skip
        }
      }

      // ── 2. Try to extract a clean name from common attributes ──

      // From name="options[Caliber]" → "Caliber"
      const nameAttr = select.getAttribute('name') || '';
      const nameMatch = nameAttr.match(/\[([^\]]+)\]$/);
      const fromName  = nameMatch ? nameMatch[1] : nameAttr.replace(/[_\-]/g, ' ');

      // From id="option1" → less useful, prefer name
      const fromId    = (id || '').replace(/[_\-]/g, ' ');

      // From placeholder option e.g. <option value="">Choose colour</option>
      const firstOption      = select.querySelector('option');
      const fromPlaceholder  = (firstOption && firstOption.value === '')
                                 ? firstOption.textContent.trim()
                                 : '';

      // From data-label or data-title if theme adds them
      const fromData = select.getAttribute('data-label') ||
                       select.getAttribute('data-title') || '';

      // ── 3. Pick the best candidate ────────────────────────────
      const label = fromData      ||
                    fromName      ||
                    fromPlaceholder ||
                    fromId;

      if (label) {
        // Capitalise first letter, lowercase rest  e.g. "Caliber"
        const formatted = label.charAt(0).toUpperCase() +
                          label.slice(1).toLowerCase();

        select.setAttribute('aria-label', 'Select ' + formatted);
      }
    });
  }

  // ── Run on DOM ready ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSelectAriaLabels);
  } else {
    addSelectAriaLabels();
  }

  // ── Re-run after full load (dynamic variant selects) ─────────
  window.addEventListener('load', addSelectAriaLabels);

  // ── Watch for selects injected by apps / variant JS ──────────
  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      const hasNewNodes = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (hasNewNodes) addSelectAriaLabels();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
//lang
(function () {
  function removeEmptyLangAttributes() {
    // Select all elements with lang="" but exclude <html> element
    const elements = document.querySelectorAll('[lang=""]');

    elements.forEach(function (el) {
      // Never touch <html> — it must always keep its lang
      if (el.tagName.toLowerCase() === 'html') return;

      el.removeAttribute('lang');
    });
  }

  // ── 1. Run on DOM ready ──────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeEmptyLangAttributes);
  } else {
    removeEmptyLangAttributes();
  }

  // ── 2. Re-run after full load (3rd party widgets) ────────────
  window.addEventListener('load', removeEmptyLangAttributes);

  // ── 3. Watch for dynamically injected elements ───────────────
  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        // Check attribute changes (lang being set to empty)
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'lang'
        ) {
          const el = mutation.target;
          if (
            el.tagName.toLowerCase() !== 'html' &&
            el.getAttribute('lang') === ''
          ) {
            el.removeAttribute('lang');
          }
          return;
        }

        // Check newly added nodes
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return; // element nodes only

          // The node itself
          if (
            node.tagName.toLowerCase() !== 'html' &&
            node.getAttribute('lang') === ''
          ) {
            node.removeAttribute('lang');
          }

          // Nested descendants inside the added node
          node.querySelectorAll('[lang=""]').forEach(function (el) {
            if (el.tagName.toLowerCase() !== 'html') {
              el.removeAttribute('lang');
            }
          });
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,           // catches lang="" being set dynamically
      attributeFilter: ['lang']   // only watch lang — avoids noise
    });
  }
})();
//tab
(function () {
  'use strict';

  function initTabSection(container) {
    const tabList = container.querySelector('[role="tablist"]');
    if (!tabList) return;

    const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function getPanel(tab) {
      const id = tab.getAttribute('aria-controls');
      return id ? container.querySelector('#' + id) : null;
    }

    function activateTab(targetTab) {
      tabs.forEach(function (tab) {
        const active = tab === targetTab;

        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');

        const panel = getPanel(tab);
        if (!panel) return;

        if (active) {
          panel.removeAttribute('hidden');   // ← was aria-hidden="false"
          panel.classList.add('active');
        } else {
          panel.setAttribute('hidden', ''); // ← was aria-hidden="true"
          panel.classList.remove('active');
        }
      });

      targetTab.focus();
    }

    // ── Click ────────────────────────────────────────────────────────────────
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    // ── Keyboard (ARIA tabs pattern) ─────────────────────────────────────────
    tabList.addEventListener('keydown', function (e) {
      const idx = tabs.indexOf(document.activeElement);
      if (idx === -1) return;

      const keyMap = {
        ArrowRight : (idx + 1) % tabs.length,
        ArrowLeft  : (idx - 1 + tabs.length) % tabs.length,
        Home       : 0,
        End        : tabs.length - 1,
      };

      if (!(e.key in keyMap)) return;
      e.preventDefault();
      activateTab(tabs[keyMap[e.key]]);
    });
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  function initAll() {
    document.querySelectorAll('[data-section-type="product-tabs"]').forEach(initTabSection);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initAll)
    : initAll();

  // Shopify theme editor live reload
  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.matches('[data-section-type="product-tabs"]')
      ? e.target
      : e.target.querySelector('[data-section-type="product-tabs"]');
    if (section) initTabSection(section);
  });

})();
//frame
(function () {
  'use strict';

  function labelVimeoFrames() {
    document
      .querySelectorAll('iframe[src*="player.vimeo.com/video/767668721"]')
      .forEach(function (iframe) {

        // 1. Accessible title on the iframe itself (WCAG 4.1.2)
        iframe.setAttribute('title', 'Tips and Tricks – Product Demo Video');

        // 2. Visible h2 heading injected immediately before the iframe
        var heading = document.createElement('h2');
        heading.className = 'vimeo-section-heading';
        heading.textContent = 'Tips and Tricks';

        iframe.parentNode.insertBefore(heading, iframe);
      });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', labelVimeoFrames)
    : labelVimeoFrames();

})();
//aria frame
(function () {
  'use strict';

  function fixYouTubeEmbeds() {
    document.querySelectorAll('iframe[src*="youtube.com/embed"]').forEach(function (iframe) {

      // ── WHAT WE CAN FIX ──────────────────────────────────────────────────
      // 1. Ensure the <iframe> element itself has an accessible title (WCAG 4.1.2)
      if (!iframe.getAttribute('title')) {
        iframe.setAttribute('title', 'YouTube Video Player');
      }

      // 2. Wrap in a labelled region so AT announces a landmark for the video
      var alreadyWrapped = iframe.parentElement.getAttribute('role') === 'region';
      if (!alreadyWrapped) {
        var region = document.createElement('div');
        region.setAttribute('role', 'region');
        region.setAttribute('aria-label', 'YouTube Video Player');
        iframe.insertAdjacentElement('beforebegin', region);
        region.appendChild(iframe);
      }

      // ── WHAT WE CANNOT FIX ───────────────────────────────────────────────
      // The div#movie_player[aria-label] is inside YouTube's cross-origin iframe.
      // The try/catch below will always throw a SecurityError and silently fail.
      // Fixing it requires YouTube to add role="application" to that div in
      // their own codebase — it is outside our control.
      iframe.addEventListener('load', function () {
        try {
          var doc = iframe.contentDocument || iframe.contentWindow.document;
          var player = doc.getElementById('movie_player');
          if (player) {
            player.setAttribute('role', 'application');
          }
        } catch (e) {
          // SecurityError: cross-origin iframe — expected, nothing to do here
        }
      });

    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fixYouTubeEmbeds)
    : fixYouTubeEmbeds();

})();
//hero
(function () {
  function fixUrlAriaLabels() {
    const links = document.querySelectorAll('a[aria-label]');

    links.forEach(function (link) {
      const label = link.getAttribute('aria-label') || '';

      // Detect if aria-label looks like a URL path
      const looksLikeUrl = /^(https?:\/\/|\/\w)/.test(label);
      if (!looksLikeUrl) return;

      // Extract last meaningful path segment
      const parts = label.replace(/\/$/, '').split('/').filter(Boolean);
      const lastSegment = parts[parts.length - 1] || '';

      // Remove query strings and hashes
      const clean = lastSegment.split('?')[0].split('#')[0];

      // Humanise: "all-products-1" → "All products 1"
      const readable = clean
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, function (c) { return c.toUpperCase(); });

      if (readable) {
        link.setAttribute('aria-label', readable);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixUrlAriaLabels);
  } else {
    fixUrlAriaLabels();
  }

  window.addEventListener('load', fixUrlAriaLabels);
})();
//product buttons
(function () {
  function labelNavigationButtons() {
    const navLists = document.querySelectorAll('.navigation-buttons__list');

    navLists.forEach(function (list) {
      const links = list.querySelectorAll('.navigation-buttons__item a');

      links.forEach(function (link) {
        const linkText = link.textContent.trim().toLowerCase();

        // ── 1. Remove empty title attribute ─────────────────────
        if (link.getAttribute('title') === '') {
          link.removeAttribute('title');
        }

        // Skip if already has a meaningful aria-label
        if (link.hasAttribute('aria-label') &&
            link.getAttribute('aria-label').trim() !== '') return;

        // ── 2. Determine direction ───────────────────────────────
        const isPrev = linkText.includes('prev') ||
                       linkText.includes('back') ||
                       linkText.includes('previous');

        const isNext = linkText.includes('next') ||
                       linkText.includes('forward');

        if (!isPrev && !isNext) return;

        const direction = isPrev ? 'Previous' : 'Next';

        // ── 3. Try to get product name from the URL ──────────────
        // e.g. /collections/laser.../products/muzzle-mounted-laser-trainer
        // → "Muzzle Mounted Laser Trainer"
        const href     = link.getAttribute('href') || '';
        const segments = href.replace(/\/$/, '').split('/').filter(Boolean);
        const lastSeg  = segments[segments.length - 1] || '';

        const productName = lastSeg
          .split('-')
          .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join(' ');

        // ── 4. Build the aria-label ──────────────────────────────
        const label = productName
          ? direction + ' product: ' + productName
          : direction + ' product';

        link.setAttribute('aria-label', label);

        // ── 5. Also update title for tooltip consistency ─────────
        link.setAttribute('title', label);
      });
    });
  }

  // ── Run on DOM ready ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelNavigationButtons);
  } else {
    labelNavigationButtons();
  }

  window.addEventListener('load', labelNavigationButtons);

  // ── Catch dynamically rendered navigation ────────────────────
  if (window.MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      const hasNewNodes = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (hasNewNodes) labelNavigationButtons();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
//product variant
(function () {
  // Track processed wrappers to prevent duplicate runs
  const processedWrappers = new WeakSet();
  // Track out-of-stock values already labelled
  const labelledChips = new WeakSet();

  function enhanceVariantChips() {
    const chipsWrappers = document.querySelectorAll('[data-option-buttons]');

    chipsWrappers.forEach(function (wrapper) {
      // ── 1. Get option name from the <label> above ────────────
      // Reads from label[for="option1"] → "Caliber"
      const productOption  = wrapper.closest('[data-product-option]');
      const labelEl        = productOption
        ? productOption.querySelector('label.product__label')
        : null;

      // label text node is "Caliber:" — strip colon and whitespace
      const rawLabel   = labelEl
        ? labelEl.childNodes[0].textContent.replace(':', '').trim()
        : '';
      const optionName = rawLabel || 'Option';

      // ── 2. Set radiogroup role + correct label (once only) ───
      wrapper.setAttribute('role', 'radiogroup');
      wrapper.setAttribute('aria-label', 'Select ' + optionName);

      // ── 3. Parse unavailable values from variant JSON ─────────
      let unavailableValues = [];
      const variantJsonEl = wrapper
        .closest('[data-enable-dynamic-product-options]')
        ?.querySelector('[data-variant-json]');

      if (variantJsonEl) {
        try {
          const variants    = JSON.parse(variantJsonEl.textContent);
          const indexAttr   = wrapper.getAttribute('data-index') || 'option1';
          const indexMatch  = indexAttr.match(/(\d+)$/);
          const optionKey   = 'option' + (indexMatch ? indexMatch[1] : '1');

          unavailableValues = variants
            .filter(function (v) { return !v.available; })
            .map(function (v) {
              return (v[optionKey] || '').toLowerCase().trim();
            });
        } catch (e) {
          console.warn('Variant JSON parse error:', e);
        }
      }

      // ── 4. Enhance each chip ─────────────────────────────────
      const chips = wrapper.querySelectorAll('[data-button]');

      chips.forEach(function (chip) {
        // role + aria-checked
        chip.setAttribute('role', 'radio');
        chip.setAttribute(
          'aria-checked',
          chip.classList.contains('selected') ? 'true' : 'false'
        );

        // ── 5. Out-of-stock — set ONCE, never append ──────────
        const chipValue     = (chip.getAttribute('data-option-value') || '')
          .toLowerCase().trim();
        const isUnavailable = chip.classList.contains('disabled') ||
                              unavailableValues.includes(chipValue);

        if (isUnavailable) {
          chip.setAttribute('aria-disabled', 'true');

          // Only set the label once — prevents repeated appending
          if (!labelledChips.has(chip)) {
            // Get the clean base label (the option value text, not any previous aria-label)
            const baseLabel = chip.getAttribute('data-option-value') ||
                              chip.textContent.trim();
            chip.setAttribute('aria-label', baseLabel + ' - Out of stock');
            labelledChips.add(chip);
          }
        } else {
          chip.removeAttribute('aria-disabled');

          // Restore clean label for available chips (in case variant availability changes)
          if (!labelledChips.has(chip)) {
            const baseLabel = chip.getAttribute('data-option-value') ||
                              chip.textContent.trim();
            chip.setAttribute('aria-label', baseLabel);
          }
        }
      });

      // ── 6. Update aria-checked on chip click ─────────────────
      // Guard: only attach listener once per wrapper
      if (!processedWrappers.has(wrapper)) {
        wrapper.addEventListener('click', function (e) {
          const clicked = e.target.closest('[data-button]');
          if (!clicked) return;

          chips.forEach(function (chip) {
            chip.setAttribute(
              'aria-checked',
              chip === clicked ? 'true' : 'false'
            );
          });
        });
        processedWrappers.add(wrapper);
      }
    });
  }

  // ── Run on DOM ready ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceVariantChips);
  } else {
    enhanceVariantChips();
  }

  window.addEventListener('load', enhanceVariantChips);

  // ── MutationObserver — debounced to prevent rapid re-runs ────
  if (window.MutationObserver) {
    let debounceTimer;

    const observer = new MutationObserver(function (mutations) {
      const hasNewNodes = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (!hasNewNodes) return;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(enhanceVariantChips, 200);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
//captcha
(function () {
  function labelHCaptchaFields() {
    // ── 1. Target all hCaptcha hidden textareas ──────────────────
    const captchaFields = document.querySelectorAll(
      'textarea[name="h-captcha-response"]:not([aria-label]):not([aria-labelledby])'
    );

    captchaFields.forEach(function (field) {
      field.setAttribute('aria-label', 'hCaptcha security verification');
      field.setAttribute('aria-hidden', 'true'); // hidden field — exclude from SR tab order
    });

    // ── 2. Also label the hCaptcha iframe if injected ────────────
    const captchaIframes = document.querySelectorAll(
      'iframe[src*="hcaptcha.com"]:not([aria-label]):not([title])'
    );

    captchaIframes.forEach(function (iframe) {
      iframe.setAttribute('aria-label', 'hCaptcha security challenge');
      iframe.setAttribute('title',      'hCaptcha security challenge');
    });

    // ── 3. Label the hCaptcha checkbox widget if present ─────────
    const captchaWidgets = document.querySelectorAll(
      '[id^="h-captcha"]:not([aria-label])'
    );

    captchaWidgets.forEach(function (widget) {
      if (widget.tagName.toLowerCase() === 'textarea') return; // already handled above
      widget.setAttribute('aria-label', 'hCaptcha security verification');
    });
  }

  // ── Run on DOM ready ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelHCaptchaFields);
  } else {
    labelHCaptchaFields();
  }

  // ── Re-run after full load (hCaptcha injects after page load) ─
  window.addEventListener('load', labelHCaptchaFields);

  // ── Watch for hCaptcha dynamic injection ─────────────────────
  if (window.MutationObserver) {
    let debounceTimer;

    const observer = new MutationObserver(function (mutations) {
      const hasNewNodes = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (!hasNewNodes) return;

      // Debounce — hCaptcha injects several elements in quick succession
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(labelHCaptchaFields, 150);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();